import { CSSProperties } from 'react';
import { borderRadius } from '../../../theme/borderRadius';
import { colors, hexToRgbA } from '../../../theme/colors';
import spacing, {
  isMobileScreen,
  spacingInUnits,
} from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';

export const simpleModalPaperDynamicSizeRootStyles: CSSProperties = {
  backgroundColor: colors.backgroundMediumLight,
  borderRadius: `${borderRadius.large + 8}px`,
  border: `1px solid ${hexToRgbA(colors.textPrimary, 0.05)}`,
};

export const simpleModalPaperFixedWidthStyles: CSSProperties = {
  width: isMobileScreen ? `calc(100% - ${spacingInUnits.medium * 2}px)` : 400,
  maxWidth: 400,
  margin: 0,
};

export const simpleModalContentContainerStyles: CSSProperties = {
  padding: spacing.mediumLarge,
};

export const simpleModalTitleStyles: CSSProperties = {
  color: colors.textPrimary,
  marginBottom: spacing.medium,
  fontSize: isMobileScreen ? fontSize.md : fontSize.lg,
  fontWeight: 'bold',
  opacity: 0.9,
};

export const simpleModalDescriptionStyles: CSSProperties = {
  color: colors.textGreyMedium,
  fontSize: isMobileScreen ? fontSize.sm : fontSize.md,
};

export const simpleModalActionsContainerStyles: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: spacing.small,
};

export const simpleActionsModalButtonStyles: CSSProperties = {
  borderRadius: 0,
  paddingTop: spacing.medium,
  paddingBottom: spacing.medium,
  background: 'transparent',
  display: 'block',
  minWidth: isMobileScreen ? '65vw' : 300,
};

export const simpleModalTitleContainerWithBackButtonStyles: CSSProperties = {
  fontSize: isMobileScreen ? fontSize.md : fontSize.lg,
  padding: spacing.medium,
  color: colors.textPrimary,
  textAlign: 'center',
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
};

export const simpleModalBackButtonContainerStyles: CSSProperties = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  top: 0,
  left: 0,
};

export const simpleModalMenuButtonStyles: CSSProperties = {
  borderRadius: 0,
  paddingTop: spacing.medium,
  paddingBottom: spacing.medium,
  background: 'transparent',
  display: 'block',
  minWidth: isMobileScreen ? '65vw' : 300,
  color: colors.textPrimary,
};

export const simpleModalMenuButtonContentStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: spacing.mediumLarge,
  justifyContent: 'flex-start',
};
